import { CalloutBanner, useRebrand } from "@growtherapy/sprout-ui";

import { faVideo } from "@fortawesome/pro-solid-svg-icons";
import { AV_PERMISSION_CALLOUT } from "../lang";

export function AVPermissionCallout() {
  const isRebrand = useRebrand();

  return (
    <CalloutBanner
      data-testid="av-permission-callout"
      use={isRebrand ? "green" : "lilac"}
      icon={isRebrand ? null : faVideo}
    >
      {AV_PERMISSION_CALLOUT}
    </CalloutBanner>
  );
}
